module.exports = __webpack_public_path__ + "img/img_logo.74b35fd0.png";